var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"production-tool-contracting-feedback success"},[_c('VueFeedback',{attrs:{"type":"success"}},[_c('template',{slot:"feedback-title"},[_vm._v("Köszönjük érdeklődését!")]),_c('template',{slot:"feedback-content"},[_vm._v("Kollégánk rövidesen keresni fogja az ajánlattal kapcsolatban.")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }